import { Link } from 'react-router-dom';

interface FooterProps {
  city: string;
}

export function Footer({ city }: FooterProps) {
  const cities = [
    { name: 'Bordeaux', path: '/bordeaux' },
    { name: 'Mérignac', path: '/merignac' },
    { name: 'Pessac', path: '/pessac' },
    { name: 'Talence', path: '/talence' },
    { name: 'Arcachon', path: '/arcachon' },
    { name: 'Libourne', path: '/libourne' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-window-line text-2xl text-teal-400"></i>
              </div>
              <span className="text-lg font-bold">FenetrePro</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Expert en réparation de fenêtres et baies vitrées en Gironde.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres PVC</a></li>
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres Aluminium</a></li>
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres Bois</a></li>
              <li><a href="#baies-vitrees" className="hover:text-teal-400 transition-colors cursor-pointer">Baies Vitrées</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Villes</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {cities.map((cityItem) => (
                <li key={cityItem.path}>
                  <Link to={cityItem.path} className="hover:text-teal-400 transition-colors cursor-pointer">
                    {cityItem.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="tel:+33554542545" className="hover:text-teal-400 transition-colors cursor-pointer">
                  05 54 54 25 45
                </a>
              </li>
              <li>
                <a href="mailto:contact@fenetrepro.fr" className="hover:text-teal-400 transition-colors cursor-pointer">
                  contact@fenetrepro.fr
                </a>
              </li>
              <li className="pt-2">
                <a 
                  href="https://wa.me/33554542545" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-green-400 hover:text-green-300 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 FenetrePro {city}. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}